<template>
  <UiCustomEmptyState
    class="py-16 md:min-h-178"
    variant="error"
    :title="$t('components.common.error.technicalProblem')"
    :description="$t('components.common.error.technicalProblemDescription')"
  >
    <template #icon>
      <SvgoCommonHeaderClose
        :font-controlled="false"
        filled
        class="h-2.5 w-2.5 text-red-700 sm:h-3.5 sm:w-3.5"
      />
    </template>
    <NuxtLinkLocale
      to="index"
      class="inline-flex h-14 items-center gap-2.5 rounded-lg bg-primary px-5 py-3 text-lg font-semibold text-primary-foreground shadow transition-colors hover:bg-brand-primary-800"
    >
      <SvgoCommonArrowNarrowLeft
        :font-controlled="false"
        filled
        aria-hidden="true"
        class="h-6 w-6 text-primary-foreground"
      />
      <span>{{ $t('components.common.error.backToHome') }}</span>
    </NuxtLinkLocale>
  </UiCustomEmptyState>
</template>
